import { render, staticRenderFns } from "./AIDashboard.vue?vue&type=template&id=3275d15f&scoped=true&"
import script from "./AIDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AIDashboard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AIDashboard.vue?vue&type=style&index=0&id=3275d15f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275d15f",
  null
  
)

export default component.exports